import React, { useState } from 'react';
import { Calendar, X } from 'lucide-react';
import SectionDivider from '../Simulation/SectionDivider';
import styles from '../../_css/Simulation.module.css';
import { notifyError } from '../../utils/helper';

const FREQUENCY_OPTIONS = [
  { id: 'daily', label: 'Daily', icon: Calendar, desc: 'Run every day' },
  { id: 'weekly', label: 'Weekly', icon: Calendar, desc: 'Run once per week' },
  { id: 'monthly', label: 'Monthly', icon: Calendar, desc: 'Run once per month' },
];

const ScheduleModal = ({
  open,
  onClose,
  schedForm,
  setSchedForm,
  onSave,
  onRemoveSchedule,
  hasExistingSchedule,
}) => {
  const [loading, setLoading] = useState(false)
  const [removeLoading, setRemoveLoading] = useState(false)
  if (!open) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  const handleSave = async() => {
    setLoading(true)
    await onSave?.()
    setLoading(false)
   
  }

  const handleRemoveSchedule = async() => {
    setRemoveLoading(true)
    await onRemoveSchedule?.()
    setRemoveLoading(false)
  }

  return (
    <div
      className={styles.runsTabModalOverlay}
      onClick={handleOverlayClick}
      onKeyDown={() => {}}
      role="dialog"
      aria-modal="true"
    >
      <div className={styles.runsTabModalBox}>
        <div className={styles.runsTabModalHeader}>
          <h3 className={styles.runsTabModalTitle}>
            Schedule Simulation Runs
          </h3>
          <button
            type="button"
            onClick={onClose}
            className={styles.runsTabModalClose}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>
        <div className={styles.runsTabModalBody}>
          <SectionDivider label="Frequency" />
          <div className={styles.runsTabFrequencyGrid}>
            {FREQUENCY_OPTIONS.map((f) => {
              const sel = schedForm.frequency === f.id;
              const Icon = f.icon;
              return (
                <div
                  key={f.id}
                  role="button"
                  tabIndex={0}
                  onClick={() =>
                    setSchedForm((p) => ({ ...p, frequency: f.id }))
                  }
                  onKeyDown={(e) =>
                    (e.key === 'Enter' || e.key === ' ') &&
                    setSchedForm((p) => ({ ...p, frequency: f.id }))
                  }
                  className={`${styles.runsTabFrequencyOption} ${sel ? styles.selected : ''}`}
                >
                  <div className={styles.runsTabFrequencyOptionHead}>
                    <Icon size={16} />
                    <span className={styles.runsTabFrequencyOptionLabel}>
                      {f.label}
                    </span>
                    {sel && (
                      <span className={styles.runsTabFrequencyCheck}>✓</span>
                    )}
                  </div>
                  <p className={styles.runsTabFrequencyOptionDesc}>
                    {f.desc}
                  </p>
                </div>
              );
            })}
          </div>
          <div className={styles.runsTabModalActions}>
            <button
              type="button"
              onClick={handleSave}
              disabled={loading}
              className={styles.runsTabSaveScheduleBtn}
              style={{ opacity: loading ? 0.5 : 1 }}
            >
              <Calendar size={16} />
             {loading ? 'Saving...' : 'Save Schedule'}
            </button>
            {hasExistingSchedule && (
              <button
                type="button"
                onClick={handleRemoveSchedule}
                disabled={removeLoading}
                style={{ opacity: removeLoading ? 0.5 : 1 }}
                className={styles.runsTabRemoveScheduleBtn}
              >
                {removeLoading ? 'Removing...' : 'Remove Schedule'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleModal;
